import { dataFolderOpenSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFolderOpenSolid = /*#__PURE__*/createIcon(dataFolderOpenSolid)
export default IconFolderOpenSolid
